import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Header from "components/Header/index";
import Sidebar from "containers/SideNav/index";
import Footer from "components/Footer";
//import Tour from '../components/Tour/index';
import {
  ABOVE_THE_HEADER,
  BELOW_THE_HEADER,
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
} from "constants/ActionTypes";
import { isIOS, isMobile } from "react-device-detect";
import asyncComponent from "../util/asyncComponent";
import TopNav from "components/TopNav";
import ColorOption from "../containers/Customizer/ColorOption";

// Live Chat imports
import { SocketProvider } from "../context/SocketContext";
import { LiveChatWidget } from "../components/LiveChat";
 
class App extends React.Component { 


  render() {
    const {
      match,
      drawerType,
      navigationStyle,
      horizontalNavPosition,
      authUser,
      selectedProject,
    } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "fixed-drawer"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "collapsible-drawer"
      : "mini-drawer";

    //set default height and overflow for iOS mobile Safari 10+ support.
    if (isIOS && isMobile) {
      document.body.classList.add("ios-mobile-view-height");
    } else if (document.body.classList.contains("ios-mobile-view-height")) {
      document.body.classList.remove("ios-mobile-view-height");
    }

    return (
      <SocketProvider authUser={authUser} selectedProject={selectedProject}>
        <div className={`app-container ${drawerStyle}`}>
          {/* <Tour/> */} 

          <Sidebar />
          <div className="app-main-container">
            <div
              className={`app-header ${
                navigationStyle === HORIZONTAL_NAVIGATION
                  ? "app-header-horizontal"
                  : ""
              }`}
            >
              {navigationStyle === HORIZONTAL_NAVIGATION &&
                horizontalNavPosition === ABOVE_THE_HEADER && (
                  <TopNav styleName="app-top-header" />
                )}
              <Header />
              {navigationStyle === HORIZONTAL_NAVIGATION &&
                horizontalNavPosition === BELOW_THE_HEADER && <TopNav />}
            </div>

            <main className="app-main-content-wrapper">
              <div className="app-main-content">
                <Switch>
                <Route
                  path={`${match.url}/mainPage`}
                  component={asyncComponent(() => import("./routes/MainPage"))}
                />
                <Route
                  exact
                  path={`${match.url}/`}
                  component={asyncComponent(() => import("./routes/MainPage"))}
                />

                <Route
                  path={`${match.url}/myRefereePage`}
                  component={asyncComponent(() =>
                    import("./routes/referee/MyRefereePage")
                  )}
                />

                <Route
                  path={`${match.url}/myItemsPage`}
                  component={asyncComponent(() =>
                    import("./routes/writer/MyItemsPage")
                  )}
                />

              
             
                <Route
                  path={`${match.url}/sendItemPage/:projectId`}
                  component={asyncComponent(() =>
                    import("./routes/writer/SendItemPage")
                  )}
                />
                   <Route
                  path={`${match.url}/sendItemPage`}
                  component={asyncComponent(() =>
                    import("./routes/writer/SendItemPage")
                  )}
                />
                    <Route
                  path={`${match.url}/adviceItemPage/:projectId`}
                  component={asyncComponent(() =>
                    import("./routes/writer/AdviceItemPage")
                  )}
                />
                 <Route
                  path={`${match.url}/adviceItemPage`}
                  component={asyncComponent(() =>
                    import("./routes/writer/AdviceItemPage")
                  )}
                />
                 <Route
                  path={`${match.url}/educationPage`}
                  component={asyncComponent(() =>
                    import("./routes/public/Education")
                  )}
                />
              
                <Route
                  path={`${match.url}/assignedItemPage`}
                  component={asyncComponent(() =>
                    import("./routes/coordinator/AssignedItemPage")
                  )}
                />
                <Route
                  path={`${match.url}/beforeAssignedItemPage`}
                  component={asyncComponent(() =>
                    import("./routes/coordinator/BeforeAssignedItemPage")
                  )}
                />
                <Route
                  path={`${match.url}/inProgressPage/:a`}
                  component={asyncComponent(() =>
                    import("./routes/editor/InProgressPage")
                  )}
                />
                 <Route
                  path={`${match.url}/inProgressPage`}
                  component={asyncComponent(() =>
                    import("./routes/editor/InProgressPage")
                  )}
                />
                <Route
                  path={`${match.url}/itemCommisionPage`}
                  component={asyncComponent(() =>
                    import("./routes/coordinator/ItemCommissionPage")
                  )}
                />
                <Route
                  path={`${match.url}/roleManagementPage`}
                  component={asyncComponent(() =>
                    import("./routes/coordinator/RoleManagementPage")
                  )}
                />
                <Route
                  path={`${match.url}/searchUserProfile`}
                  component={asyncComponent(() =>
                    import("./routes/public/SearchUserProfile")
                  )}
                />
                <Route
                  path={`${match.url}/showUserProfile/:id`}
                  component={asyncComponent(() =>
                    import("./routes/public/ShowUserProfile")
                  )}
                />
                <Route
                  path={`${match.url}/itemReview/:id`}
                  component={asyncComponent(() =>
                    import("./routes/referee/ItemReviewPage")
                  )}
                />
                <Route
                  path={`${match.url}/inInstitutions/:a`}
                  component={asyncComponent(() =>
                    import("./routes/editor/InInstitutionsPage")
                  )}
                />
                 <Route
                  path={`${match.url}/inInstitutions`}
                  component={asyncComponent(() =>
                    import("./routes/editor/InInstitutionsPage")
                  )}
                />
         
                     <Route
                  path={`${match.url}/ItemPoolPage`}
                  component={asyncComponent(() =>
                    import("./routes/editor/ItemPoolPage")
                  )}
                />

                  <Route
                  path={`${match.url}/ComplatedPage`}
                  component={asyncComponent(() =>
                    import("./routes/editor/ComplatedPage")
                  )}
                />
                     <Route
                  path={`${match.url}/PublicationPage`}
                  component={asyncComponent(() =>
                    import("./routes/editor/PublicationPage")
                  )}
                />
                  <Route
                  path={`${match.url}/ip/:id`}
                  component={asyncComponent(() =>
                    import("./routes/editor/ItemPage")
                  )}
                />

                    <Route
                  path={`${match.url}/ItemIndexPage`}
                  component={asyncComponent(() =>
                    import("./routes/editor/ItemIndexPage")
                  )}
                />
                  <Route
                  path={`${match.url}/WriterIndexPage`}
                  component={asyncComponent(() =>
                    import("./routes/editor/WriterIndexPage")
                  )}
                />
                 <Route
                  path={`${match.url}/royaltyCalculationPage`}
                  component={asyncComponent(() =>
                    import("./routes/coordinator/RoyaltyCalculationPage")
                  )}
                />
               <Route
                  path={`${match.url}/webMessagesDetailPage`}
                  component={asyncComponent(() =>
                    import("./routes/public/webMessages/WebMessagesDetail")
                  )}
                />
  <Route
                  path={`${match.url}/webMessagesPanelPage/:id/:questionId`}
                  component={asyncComponent(() =>
                    import("./routes/public/webMessages/MessagesPanel")
                  )}
                />
                <Route
                  path={`${match.url}/statisticsPage`}
                  component={asyncComponent(() =>
                    import("./routes/hightCoordinator/StatisticsPage")
                  )}
                /> 

                
                   <Route
                  path={`${match.url}/projectManagementPage`}
                  component={asyncComponent(() =>
                    import("./routes/aykCoordinator/ProjectManagementPage")
                  )}
                />
   

   <Route
                  path={`${match.url}/updateItemPage`}
                  component={asyncComponent(() =>
                    import("./routes/writer/UpdateItemPage")
                  )}
                />
              
                 <Route
                  path={`${match.url}/searchItem/:kw`}
                  component={asyncComponent(() =>
                    import("./routes/public/SearchItem")
                  )}
                />
                  <Route
                  path={`${match.url}/searchItem`}
                  component={asyncComponent(() =>
                    import("./routes/public/SearchItem")
                  )}
                />
                  <Route
                  path={`${match.url}/myProfile`}
                  component={asyncComponent(() =>
                    import("./routes/public/MyProfilePage")
                  )}
                />
                  <Route
                  path={`${match.url}/settings`}
                  component={asyncComponent(() =>
                    import("./routes/coordinator/SettingsPage")
                  )}
                />
                   

                 <Route
                  path={`${match.url}/faq`}
                  component={asyncComponent(() =>
                    import("./routes/public/FAQ")
                  )}
                />
                <Route
                  path={`${match.url}/invitedWriter`}
                  component={asyncComponent(() =>
                    import("./routes/editor/InvitedWriterPage")
                  )}
                />
                     <Route
                  path={`${match.url}/messageManagementPage`}
                  component={asyncComponent(() =>
                    import("./routes/hightCoordinator/MessageManagementPage")
                  )}
                />

<Route
                  path={`${match.url}/translatePage`}
                  component={asyncComponent(() =>
                    import("./routes/translator/TranslatePage")
                  )}
                />
<Route
                  path={`${match.url}/proofreaderPage`}
                  component={asyncComponent(() =>
                    import("./routes/proofreader/ProofreaderPage")
                  )}
                />
                <Route
                  path={`${match.url}/editorPage`}
                  component={asyncComponent(() =>
                    import("./routes/proofreader/ProofreaderPage")
                  )}
                />

<Route
                  path={`${match.url}/itemPrinciplesPage`}
                  component={asyncComponent(() =>
                    import("./routes/public/ItemPrinciplesPage")
                  )}
                />
<Route
                  path={`${match.url}/sendItemWriterPage`}
                  component={asyncComponent(() =>
                    import("./routes/editor/SendItemWriterPage")
                  )}
                /> 
<Route
                  path={`${match.url}/otherDictionaryPage`}
                  component={asyncComponent(() =>
                    import("./routes/editor/OtherDictionaryPage")
                  )}
                />

<Route
                  path={`${match.url}/itemsMapPage`}
                  component={asyncComponent(() =>
                    import("./routes/editor/ItemMapPage")
                  )}
                />
<Route
                  path={`${match.url}/suggestItemPage`}
                  component={asyncComponent(() =>
                    import("./routes/coordinator/SuggestItemPage")
                  )}
                />



                <Route
                  path={`${match.url}/401`}
                  component={asyncComponent(() =>
                    import("components/Error401")
                  )}
                />
                   <Route
                  path={`${match.url}/403`}
                  component={asyncComponent(() =>
                    import("components/Error403")
                  )}
                />
                <Route
                  component={asyncComponent(() =>
                    import("components/Error404")
                  )}
                />
                </Switch>
              </div>
              <Footer />
            </main>
          </div>
          <ColorOption></ColorOption>
          
          {/* Canlı Destek Chat Widget */}
          {authUser && (
            <LiveChatWidget 
              authUser={authUser} 
              selectedProject={selectedProject} 
            />
          )}
        </div>
      </SocketProvider>
    );
  }
}

const mapStateToProps = ({ settings, auth, item }) => {
  const { drawerType, navigationStyle, horizontalNavPosition } = settings;
  const { authUser } = auth;
  const { selectedProject } = item;
  return { drawerType, navigationStyle, horizontalNavPosition, authUser, selectedProject };
};
export default withRouter(connect(mapStateToProps)(App));
